import t from "../../../i18n";
import { colors } from "@ui/Theme";
import { spacings } from "@ui/Theme/spacings";
import type { Reparability } from "../../../api/Reparability";
import { useTranslations } from "../../../api/useTranslations";

// ================================
// Types and Interfaces
// ================================

export interface FaultMapping {
  name: string;
  group: string;
}

// ================================
// Fault Grouping Data
// ================================

// Fault grouping data from faults.JSON
export const FAULT_MAPPINGS: FaultMapping[] = [
  { name: "Degardage_TubeU_301*", group: "Dégardage tube en U ABP" },
  { name: "Degardage_TubeU_302*", group: "Dégardage tube en U ABP" },
  { name: "Degardage_TubeU_303*", group: "Dégardage tube en U ABP" },
  { name: "Degardage_TubeU_201RE*", group: "Dégardage tube en U ABP" },
  { name: "Degardage_TubeU_202RE*", group: "Dégardage tube en U ABP" },
  { name: "Degardage_TubeU_203RE*", group: "Dégardage tube en U ABP" },
  { name: "Obstruction_Condenseur_Ete", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_Hiver", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File1", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File2", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File1_BAS_vide", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File1_HAUT_vide", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File2_BAS_vide", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File2_HAUT_vide", group: "Obstruction condenseur" },
  { name: "Obstruction_File1_Condenseur_Ete", group: "Obstruction condenseur" },
  { name: "Obstruction_File1_Condenseur_Hiver", group: "Obstruction condenseur" },
  { name: "Obstruction_File2_Condenseur_Ete", group: "Obstruction condenseur" },
  { name: "Obstruction_File2_Condenseur_Hiver", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File1_Ete", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File1_Hiver", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File2_Ete", group: "Obstruction condenseur" },
  { name: "Obstruction_Condenseur_File2_Hiver", group: "Obstruction condenseur" },
  { name: "Pertes_aero*", group: "Pertes aéro" },
  { name: "Pertes_aero_CEF", group: "Pertes aéro" },
  { name: "Pertes_aero", group: "Pertes aéro" },
  { name: "Perte_aero", group: "Pertes aéro" },
  { name: "Perte_aero*", group: "Pertes aéro" },
  { name: "COP_Aero", group: "Pertes aéro" },
  { name: "Perte_aero_CEF", group: "Pertes aéro" },
  { name: "perte_aero_ETOA", group: "Pertes aéro" },
  { name: "Perte_Condenseur*", group: "Pertes condenseur" },
  { name: "Perte Condenseur*", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur*", group: "Pertes condenseur" },
  { name: "COP_Condenseur", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_Ete*", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_Hiver*", group: "Pertes condenseur" },
  { name: "Perte_Condenseur_Entree_dair_Ete", group: "Présence incondensables au condenseur" },
  { name: "Perte_Condenseur_Entree_dair_Hiver", group: "Présence incondensables au condenseur" },
  { name: "Perte_Condenseur_Ete*", group: "Pertes condenseur" },
  { name: "Perte_Condenseur_Hiver*", group: "Pertes condenseur" },
  { name: "Perte_Condenseur_Obstruction", group: "Obstruction condenseur" },
  { name: "Perte_Condenseur_Entree_dair", group: "Présence incondensables au condenseur" },
  { name: "Perte_Condenseur", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_BAS_vide*", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_HAUT_vide*", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_BAS_vide", group: "Pertes condenseur" },
  { name: "Pertes_Condenseur_HAUT_vide", group: "Pertes condenseur" },
  { name: "Condenseur_entree_air", group: "Présence incondensables au condenseur" },
  { name: "Efficacite Condenseur", group: "Pertes condenseur" },
  { name: "Efficacite_Condenseur", group: "Pertes condenseur" },
  { name: "Encrassement_Condenseur", group: "Pertes condenseur" },
  { name: "Presence_incondensables", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensables_Ete", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensables_Hiver", group: "Présence incondensables au condenseur" },
  { name: "INCOND_Condenseur", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensable", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensables_BAS_vide", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensables_HAUT_vide", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensable_Ete", group: "Présence incondensables au condenseur" },
  { name: "Presence_incondensable_Hiver", group: "Présence incondensables au condenseur" },
  { name: "Sous-debit_turbine*", group: "Sous-débit turbiné" },
  { name: "Sous-debit turbine*", group: "Sous-débit turbiné" },
  { name: "Sous-debit_turbine", group: "Sous-débit turbiné" },
  { name: "Sous_debit_turbine*", group: "Sous-débit turbiné" },
];

// ================================
// Cost and Time Constants
// ================================

export const COST_PER_MWH = 60; // euros per MWh

export const TIME_FIX_ONLINE_WEEKS = 3;
export const TIME_FIX_ONLINE_HOURS = TIME_FIX_ONLINE_WEEKS * 7 * 24;

export const TIME_ONE_TO_THREE_DAYS_MONTHS = 2;
export const TIME_ONE_TO_THREE_DAYS_HOURS = TIME_ONE_TO_THREE_DAYS_MONTHS * 30 * 24;
export const TIME_FOUR_PLUS_DAYS_HOURS = 7000;

export const REPARABILITY_TIME_TO_FIX: Record<Reparability, number> = {
  REPARABILITY_0: TIME_FIX_ONLINE_HOURS,
  REPARABILITY_1: TIME_ONE_TO_THREE_DAYS_HOURS,
  REPARABILITY_2: TIME_FOUR_PLUS_DAYS_HOURS,
};

// ================================
// Impact Range Constants
// ================================

export interface ImpactRange {
  min: number;
  max: number;
  label: string;
}

export const IMPACT_RANGES: ImpactRange[] = [
  { min: 0, max: 1, label: `${t("customization.table.translation.losses")} < 1 MW` },
  { min: 1, max: 3, label: `1 MW < ${t("customization.table.translation.losses")} < 3 MW` },
  { min: 3, max: 5, label: `3 MW < ${t("customization.table.translation.losses")} < 5 MW` },
  { min: 5, max: Infinity, label: `${t("customization.table.translation.losses")} > 5 MW` },
];

// ================================
// Utility Functions
// ================================

const FAULT_GROUP_MAP = new Map<string, string>();
for (const fault of FAULT_MAPPINGS) {
  FAULT_GROUP_MAP.set(fault.name, fault.group);
}

/**
 * Get the display name for a failure, with fallback to group mapping or technical name
 * @param failure - The failure object or failure name string
 * @returns The display name if available, group name if found in mappings, otherwise the technical name
 */
export const getFailureGroupName = (failure: string | MatrixFailure): string => {
  let failureName = "";
  if (typeof failure === "object" && failure.displayName) {
    failureName = failure.displayName;
  } else if (typeof failure === "string") {
    failureName = failure;
  } else {
    failureName = failure.name;
  }

  const groupName = FAULT_GROUP_MAP.get(failureName);
  if (groupName) {
    return groupName;
  }

  // Fallback to the failureName if no group is found
  return failureName;
};

/**
 * Cost calculation utility using proper reparability keys
 * @param impactMW - Impact in MW
 * @param reparabilityKey - Reparability key (REPARABILITY_0, REPARABILITY_1, REPARABILITY_2)
 * @returns Calculated cost in euros
 */
export const calculateCost = (impactMW: number, reparabilityKey: Reparability): number => {
  const timeToFixHours = REPARABILITY_TIME_TO_FIX[reparabilityKey] || 0;
  return Math.abs(impactMW) * timeToFixHours * COST_PER_MWH;
};

/**
 * Format monetary values for display
 * @param value - Value in euros
 * @returns Formatted string
 */
export const formatMonetaryValue = (value: number): string => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1).replace(/\.0$/, "")} M€`;
  } else if (value > 1000) {
    return `${Math.round(value / 1000)} k€`;
  } else if (value === 0) {
    return "0 k€";
  } else {
    const inThousands = Math.round(value / 100) / 10;
    if (inThousands === 0) {
      return "0.1 k€";
    }
    return `${inThousands.toFixed(1)} k€`;
  }
};

// ================================
// Reparability Constants
// ================================

// Use the actual reparability keys instead of hardcoded categories
export const REPARABILITY_CATEGORIES: Reparability[] = [
  "REPARABILITY_0",
  "REPARABILITY_1",
  "REPARABILITY_2",
];

/**
 * Get reparability categories for matrix building (using actual keys)
 * @returns Array of reparability keys
 */
export const getReparabilityCategories = (): Reparability[] => REPARABILITY_CATEGORIES;

/**
 * Hook to get reparability descriptions for display
 * @returns Array of reparability descriptions
 */
export const useReparabilityDescriptions = (): string[] => {
  const translations = useTranslations();

  return [
    t("reparability", "REPARABILITY_0", translations),
    t("reparability", "REPARABILITY_1", translations),
    t("reparability", "REPARABILITY_2", translations),
  ];
};

// ================================
// Trigram Generation Utilities
// ================================

/**
 * Create a trigram from project name with special case handling
 * @param projectName - The project name
 * @returns Generated trigram
 */
export const createTrigram = (projectName: string): string => {
  if (projectName.startsWith("SAINT ALBAN")) {
    const match = projectName.match(/SAINT ALBAN (\S)/i);
    if (match && match[1]) {
      return `SAL${match[1]}`;
    }
  } else if (projectName.startsWith("SAINT-LAURENT-DES-EAUX")) {
    const secondMatch = projectName.match(/SAINT-LAURENT-DES-EAUX (\S\S)/i);
    if (secondMatch && secondMatch[1]) {
      return `SL${secondMatch[1]}`;
    }
  } else if (projectName.startsWith("CHOOZ")) {
    const match = projectName.match(/CHOOZ (\S+)/i);
    if (match && match[1]) {
      if (match[1].startsWith("B") && /^B[123]$/.test(match[1])) {
        return `CHZ${match[1].substring(1)}`;
      }
      return `CHZ${match[1]}`;
    }
  } else if (projectName.startsWith("CHINON")) {
    const match = projectName.match(/CHINON (\S\S)/i);
    if (match && match[1]) {
      return `CH${match[1]}`;
    }
  }

  const parts = projectName.split(" ");
  let firstPart = "";
  let secondPart = "";

  if (parts.length >= 1 && parts[0]) {
    firstPart = parts[0].substring(0, 3).toUpperCase();
  }
  if (parts.length >= 2 && parts[1]) {
    secondPart = parts[1];
  }

  if (firstPart && secondPart) {
    return `${firstPart}${secondPart}`;
  }

  if (parts.length < 2 || !parts[1]) {
    return projectName.substring(0, 4).toUpperCase();
  }

  return projectName.substring(0, 4).toUpperCase();
};

// ================================
// Matrix Data Building Utilities
// ================================

export interface MatrixEntry {
  system: string;
  failure: MatrixFailure;
  plant: string;
  trigram: string;
  impact: number;
  degradationType: string;
  equipmentType: string;
  isRecurrentFault: boolean;
  failureId: string;
  projectId: string;
  hasUnknownReparability?: boolean;
}

export interface CellEntry {
  itemName: string;
  plantName: string;
  trigram: string;
  impactValue: number;
  isRecurrentFault: boolean;
  hasUnknownReparability?: boolean;
}

/**
 * Check if a fault was present in the previous month for recurring fault detection
 * @param currentFailureId - Current failure ID
 * @param currentProjectId - Current project ID
 * @param selectedYear - Selected year
 * @param selectedMonth - Selected month
 * @param reporting - Reporting data to check
 * @returns True if fault was present in previous month
 */
export const checkFaultInPreviousMonth = (
  currentFailureId: string,
  currentProjectId: string,
  selectedYear: number,
  selectedMonth: number,
  reporting: MatrixReporting,
): boolean => {
  if (!selectedYear || !selectedMonth) return false;

  let previousYear = selectedYear;
  let previousMonth = selectedMonth - 1;

  if (previousMonth <= 0) {
    previousMonth = 12;
    previousYear = selectedYear - 1;
  }

  const previousPeriod = reporting.periods?.find((period: MatrixPeriodReporting) => {
    const periodDate = new Date(period.period);
    return periodDate.getFullYear() === previousYear && periodDate.getMonth() + 1 === previousMonth;
  });

  if (!previousPeriod) {
    return false;
  }

  const foundFault =
    previousPeriod.values?.some(
      (value: { projectId: string; impacts?: { failureId: string }[] }) => {
        if (value.projectId !== currentProjectId) return false;
        return value.impacts?.some(
          (impact: { failureId: string }) => impact.failureId === currentFailureId,
        );
      },
    ) ?? false;

  return foundFault;
};

// ================================
// Matrix Building Utilities
// ================================

/**
 * Initialize empty matrix structure using reparability keys
 * @param reparabilityCategories - Array of reparability keys
 * @param impactRanges - Array of impact range objects
 * @returns Empty matrix structure
 */
export const initializeMatrix = <T>(
  reparabilityCategories: Reparability[],
  impactRanges: ImpactRange[],
): { [reparabilityCategory: string]: { [impactRange: string]: T[] } } => {
  const matrix: { [reparabilityCategory: string]: { [impactRange: string]: T[] } } = {};

  for (const repCategory of reparabilityCategories) {
    matrix[repCategory] = {};
    for (const range of impactRanges) {
      matrix[repCategory][range.label] = [];
    }
  }

  return matrix;
};

/**
 * Convert an impact value to its corresponding impact range
 * @param impactValue - The impact value in MW
 * @param impactRanges - Array of impact ranges to check against
 * @returns The matching impact range or undefined
 */
export const getImpactRange = (
  impactValue: number,
  impactRanges: ImpactRange[] = IMPACT_RANGES,
): ImpactRange | undefined =>
  impactRanges.find(range => impactValue >= range.min && impactValue < range.max);

// ================================
// Matrix Cell Color Logic
// ================================

/**
 * Calculate border/background color for matrix cells based on reparability and impact severity
 * @param repairIndex - Index of reparability category (0=TEM, 1=ATF, 2=AT)
 * @param impactIndex - Index of impact range (0=>5MW, 1=3-5MW, 2=1-3MW, 3=<1MW)
 * @returns Hex color string for the cell
 */
export const getBorderColor = (repairIndex: number, impactIndex: number): string => {
  const greenCells = [
    [0, 0], // TEM + <1MW
    [1, 0], // ATF + <1MW
    [0, 1], // TEM + 1-3MW
  ];

  const orangeCells = [
    [0, 2], // TEM + 3-5MW
    [0, 3], // TEM + >5MW
    [1, 1], // ATF + 1-3MW
    [2, 0], // AT + <1MW
  ];

  const redCells = [
    [1, 2], // ATF + 3-5MW
    [1, 3], // ATF + >5MW
    [2, 1], // AT + 1-3MW
    [2, 2], // AT + 3-5MW
    [2, 3], // AT + >5MW
  ];

  const isGreen = greenCells.some(
    ([repairIdx, impactIdx]) => repairIdx === repairIndex && impactIdx === impactIndex,
  );

  const isOrange = orangeCells.some(
    ([repairIdx, impactIdx]) => repairIdx === repairIndex && impactIdx === impactIndex,
  );

  const isRed = redCells.some(
    ([repairIdx, impactIdx]) => repairIdx === repairIndex && impactIdx === impactIndex,
  );

  if (isGreen) {
    return colors.chart_categorical_green;
  } else if (isOrange) {
    return colors.chart_categorical_orange;
  } else if (isRed) {
    return colors.chart_categorical_red;
  } else {
    return colors.titanium700;
  }
};

/**
 * Get lighter background color based on border color for XLSX styling
 * @param borderColor - The border color hex string
 * @returns Lighter background color hex string
 */
export const getLighterBackgroundColor = (borderColor: string): string => {
  const colorMap: Record<string, string> = {
    [colors.chart_categorical_green]: "#E8F5E8",
    [colors.chart_categorical_orange]: "#FFF3CD",
    [colors.chart_categorical_red]: "#F8D7DA",
    [colors.titanium700]: "#F8F9FA",
  };

  return colorMap[borderColor] || "#F8F9FA";
};

/**
 * Enhanced background color calculation for XLSX export with better visibility
 * @param repairIndex - Index of reparability category
 * @param impactIndex - Index of impact range
 * @param hasData - Whether the cell contains data
 * @returns Background color hex string (without #)
 */
export const getExcelBackgroundColor = (
  repairIndex: number,
  impactIndex: number,
  hasData: boolean,
): string => {
  if (!hasData) return "F8F9FA"; // Light gray for empty cells

  const borderColor = getBorderColor(repairIndex, impactIndex);

  // Excel-specific color mapping (without # prefix)
  const colorMap: Record<string, string> = {
    [colors.chart_categorical_green]: "E8F5E8",
    [colors.chart_categorical_orange]: "FFF3CD",
    [colors.chart_categorical_red]: "F8D7DA",
    [colors.titanium700]: "F8F9FA",
  };

  return colorMap[borderColor] || "F8F9FA";
};

// ================================
// Types and Interfaces for Matrix Building
// ================================

export interface MatrixFilters {
  selectedYear: number;
  selectedMonth: number;
  selectedPlants: string[];
  displayMode?: "failure" | "system" | "degradationType" | "equipmentType";
  useColorfulPlants?: boolean;
}

export interface MatrixImpact {
  failureId: string;
  reparability?: string;
  value: string | number;
}

export interface MatrixProjectValue {
  projectId: string;
  qoiId: string;
  impacts: MatrixImpact[];
}

export interface MatrixPeriodReporting {
  period: string | number;
  values: MatrixProjectValue[];
}

export interface MatrixProject {
  name: string;
  siteId?: string;
  typeId?: string;
}

export interface MatrixFailure {
  name: string;
  displayName?: string;
  failureCategoryId?: string;
  systemId?: string;
  degradationTypeId?: string;
  equipmentTypeId?: string;
}

export interface MatrixReporting {
  periods: MatrixPeriodReporting[];
  projectById: Record<string, MatrixProject>;
  failureById: Record<string, MatrixFailure>;
  qoiById: Record<string, { name: string }>;
}

export interface MatrixData<T> {
  matrix: { [reparabilityCategory: string]: { [impactRange: string]: T[] } };
  reparabilityCategories: Reparability[];
  impactRanges: ImpactRange[];
  projectTrigrams: Map<string, string>;
  totalEntries: number;
}

export type ReparabilityKey = "REPARABILITY_0" | "REPARABILITY_1" | "REPARABILITY_2";

export interface Translation {
  [key: string]: string | Record<string, string>; // Support nested translation objects
}

// ================================
// Shared Matrix Building Logic
// ================================

/**
 * Centralized matrix building function that works with raw reparability keys
 * @param reporting - Matrix reporting data structure
 * @param filters - Matrix filters including date, plants, and display options
 * @param _translation - Translation object (unused - kept for backward compatibility)
 * @param _tFunction - Translation function (unused - kept for backward compatibility)
 * @param entryBuilder - Function to build matrix entries
 * @returns MatrixData with built matrix, categories, ranges, and metadata
 */
export const buildReparabilityMatrix = <T = MatrixEntry | CellEntry>(
  reporting: MatrixReporting,
  filters: MatrixFilters,
  _translation: Translation,
  _tFunction: (key: string, value: ReparabilityKey, translation: Translation) => string,
  entryBuilder: (params: {
    failure: MatrixFailure;
    project: MatrixProject;
    trigram: string;
    impactValue: number;
    isRecurrentFault: boolean;
    hasUnknownReparability: boolean;
    impact: MatrixImpact;
    projectId: string;
  }) => T,
): MatrixData<T> => {
  const reparabilityCategories = getReparabilityCategories();

  const impactRanges = IMPACT_RANGES;

  const matrix = initializeMatrix<T>(reparabilityCategories, impactRanges);

  const projectTrigrams = new Map<string, string>();

  let totalEntries = 0;

  const filteredPeriods = reporting.periods.filter((dateReporting: MatrixPeriodReporting) => {
    if (filters.selectedYear === 0 || filters.selectedMonth === 0) return true;

    const date = new Date(dateReporting.period);
    return (
      date.getFullYear() === filters.selectedYear && date.getMonth() + 1 === filters.selectedMonth
    );
  });

  interface RawEntry {
    failure: MatrixFailure;
    project: MatrixProject;
    trigram: string;
    impactValue: number;
    isRecurrentFault: boolean;
    hasUnknownReparability: boolean;
    impact: MatrixImpact;
    projectId: string;
    reparabilityKey: Reparability;
  }

  const rawEntries: RawEntry[] = [];

  for (const dateReporting of filteredPeriods) {
    for (const value of dateReporting.values) {
      if (filters.selectedPlants.length > 0 && !filters.selectedPlants.includes(value.projectId)) {
        continue;
      }

      for (const impact of value.impacts) {
        const project = reporting.projectById[value.projectId];
        const failure = reporting.failureById[impact.failureId];

        if (!project || !failure) {
          continue;
        }

        let trigram = projectTrigrams.get(project.name);
        if (!trigram) {
          trigram = createTrigram(project.name);
          projectTrigrams.set(project.name, trigram);
        }

        if (!trigram) continue;

        const reparabilityKey = impact.reparability as Reparability;
        const hasUnknownReparability = !reparabilityKey;

        // Default unknown reparability to REPARABILITY_1 (ATF)
        const finalReparabilityKey = reparabilityKey || "REPARABILITY_1";

        if (!reparabilityCategories.includes(finalReparabilityKey)) {
          continue;
        }

        const rawImpactValue = Number(impact.value);

        // Skip faults with positive impact (surdébit turbiné)
        if (rawImpactValue >= 0) {
          continue;
        }

        const impactValue = Math.abs(rawImpactValue);

        const isRecurrentFault = checkFaultInPreviousMonth(
          impact.failureId,
          value.projectId,
          filters.selectedYear,
          filters.selectedMonth,
          reporting,
        );

        rawEntries.push({
          failure,
          project,
          trigram,
          impactValue,
          isRecurrentFault,
          hasUnknownReparability,
          impact,
          projectId: value.projectId,
          reparabilityKey: finalReparabilityKey,
        });
      }
    }
  }

  const aggregatedGroups = new Map<
    string,
    {
      entries: RawEntry[];
      totalImpact: number;
      reparabilityKey: Reparability;
      failure: MatrixFailure;
      project: MatrixProject;
      trigram: string;
      hasAnyRecurrentFault: boolean;
      hasAnyUnknownReparability: boolean;
    }
  >();

  // Group raw entries by failure display name + trigram + reparability
  for (const rawEntry of rawEntries) {
    const failureDisplayName = getFailureGroupName(rawEntry.failure);
    const groupKey = `${failureDisplayName}|${rawEntry.trigram}|${rawEntry.reparabilityKey}`;

    if (aggregatedGroups.has(groupKey)) {
      const existing = aggregatedGroups.get(groupKey)!;
      existing.entries.push(rawEntry);
      existing.totalImpact += rawEntry.impactValue;
      existing.hasAnyRecurrentFault = existing.hasAnyRecurrentFault || rawEntry.isRecurrentFault;
      existing.hasAnyUnknownReparability =
        existing.hasAnyUnknownReparability || rawEntry.hasUnknownReparability;
    } else {
      aggregatedGroups.set(groupKey, {
        entries: [rawEntry],
        totalImpact: rawEntry.impactValue,
        reparabilityKey: rawEntry.reparabilityKey,
        failure: rawEntry.failure,
        project: rawEntry.project,
        trigram: rawEntry.trigram,
        hasAnyRecurrentFault: rawEntry.isRecurrentFault,
        hasAnyUnknownReparability: rawEntry.hasUnknownReparability,
      });
    }
  }

  // Place aggregated groups in matrix based on their total aggregated impact
  for (const [, group] of aggregatedGroups) {
    if (group.entries.length === 0) {
      continue;
    }

    const impactRange = getImpactRange(group.totalImpact, impactRanges);

    if (!impactRange) {
      continue;
    }

    // Use the first entry for the representative impact object, but with aggregated impact value
    const representativeEntry = group.entries[0]!;

    const entry = entryBuilder({
      failure: group.failure,
      project: group.project,
      trigram: group.trigram,
      impactValue: group.totalImpact, // Use aggregated impact
      isRecurrentFault: group.hasAnyRecurrentFault,
      hasUnknownReparability: group.hasAnyUnknownReparability,
      impact: representativeEntry.impact,
      projectId: representativeEntry.projectId,
    });

    if (!matrix[group.reparabilityKey]) {
      matrix[group.reparabilityKey] = {};
    }
    if (!matrix[group.reparabilityKey]![impactRange.label]) {
      matrix[group.reparabilityKey]![impactRange.label] = [];
    }
    matrix[group.reparabilityKey]![impactRange.label]!.push(entry);
    totalEntries++;
  }

  return {
    matrix,
    reparabilityCategories,
    impactRanges,
    projectTrigrams,
    totalEntries,
  };
};

export const buildMatrixEntry = (params: {
  failure: MatrixFailure;
  project: MatrixProject;
  trigram: string;
  impactValue: number;
  isRecurrentFault: boolean;
  hasUnknownReparability: boolean;
  impact: MatrixImpact;
  projectId: string;
}): MatrixEntry => ({
  system: params.failure.systemId || "Unknown",
  failure: params.failure,
  plant: params.project.name,
  trigram: params.trigram,
  impact: params.impactValue,
  degradationType: params.failure.degradationTypeId || "Unknown",
  equipmentType: params.failure.equipmentTypeId || "Unknown",
  isRecurrentFault: params.isRecurrentFault,
  failureId: params.impact.failureId,
  projectId: params.projectId,
  hasUnknownReparability: params.hasUnknownReparability,
});

export const buildCellEntry = (params: {
  failure: MatrixFailure;
  project: MatrixProject;
  trigram: string;
  impactValue: number;
  isRecurrentFault: boolean;
  hasUnknownReparability: boolean;
}): CellEntry => ({
  itemName: params.failure.displayName || params.failure.name,
  plantName: params.project.name,
  trigram: params.trigram,
  impactValue: params.impactValue,
  isRecurrentFault: params.isRecurrentFault,
  hasUnknownReparability: params.hasUnknownReparability,
});

// ================================
// Matrix UI Constants
// ================================

/**
 * UI-specific constants for matrix display in the web interface
 */
export const MATRIX_UI_CONSTANTS = {
  MATRIX_GAP: spacings.xs,
  Y_AXIS_WIDTH: 36,
  HEADER_CELL_PADDING: spacings.xs,

  FONT_SIZE_SMALL: 12,
  HEADER_BORDER_RADIUS: spacings.xxs,

  HEADER_BACKGROUND: colors.titanium100,
  HEADER_TEXT_COLOR: colors.carbon800,

  MAX_VISIBLE_FAULTS_THRESHOLD: 10,
} as const;

// ================================
// Excel Export Constants
// ================================

/**
 * Excel-specific constants for matrix export functionality
 */
export const EXCEL_CONSTANTS = {
  HEADER_ROW_INDEX: 3,
  MIN_ROWS_PER_IMPACT_RANGE: 1,
  COLUMNS_PER_REPARABILITY_CATEGORY: 3, // failure name, trigram, impact

  COLUMN_WIDTHS: {
    IMPACT_RANGE: 18,
    FAILURE_NAME: 25,
    PLANT_TRIGRAM: 15,
    IMPACT_VALUE: 12,
  } as const,

  ROW_HEIGHTS: {
    STANDARD_DATA: 25,
    HEADER: 40,
  } as const,

  COLORS: {
    CORNER_CELL: "D6EDFF",
    CATEGORY_HEADER: "E3F2FD",
    SUB_HEADER: "F0F8FF",
    IMPACT_RANGE_BACKGROUND: "E8F4FD",

    PRIMARY_TEXT: "1565C0",
    SECONDARY_TEXT: "1976D2",
    DATA_TEXT: "000000",
    MUTED_TEXT: "666666",

    THICK_BORDER: "1976D2",
    THIN_BORDER: "CCCCCC",

    SPECIAL_RANGE_BORDER: "1976D2",
  } as const,

  FONT_SIZES: {
    CORNER_CELL: 11,
    CATEGORY_HEADER: 10,
    SUB_HEADER: 9,
    DATA_CELL: 9,
    IMPACT_LABEL: 10,
    FINANCIAL_HEADER: 12,
    FINANCIAL_DATA: 11,
  } as const,

  SPECIAL_COLUMNS: {
    AFTER_FIX_ONLINE: 4, // Column position after "Fix on-line" category ends
    ATF_CATEGORY_INDEX: 1, // Index of ATF (1-3 outage days) category
  } as const,
} as const;
